
if ($('.multi-option-filter').length > 0) {

    $('.multi-option-filter').each(function() {
        var triggers = $('[data-filter-trigger]');
        $(triggers).each(function() {
            $(this).change(function () {
                var selectedCount = 0;
                $('[data-filter-id]').addClass('hidden');

                $(triggers).each(function() {
                    var type = $(this).attr('type');
                    var target = $('[data-filter-id="' + $(this).prop('value') +'"]');

                    if ($(this).prop('checked') && (type === 'checkbox' || type === 'radio')) {
                        $(target).removeClass('hidden');
                        selectedCount++;
                    } else {
                        $(target).find('input').prop('checked', false);
                    }
                    if(type !== 'checkbox' && type !== 'radio') {
                        $(target).removeClass('hidden');
                        selectedCount++;
                    }

                    if (selectedCount === 0) {
                        $('[data-filter-placeholder]').removeClass('hidden');
                    } else {
                        $('[data-filter-placeholder]').addClass('hidden');
                    }
                });
            });
        });
    });
}

